import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["inputProps", "name", "placeholder", "validate"];
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { useField } from 'react-final-form';
import { jsx as _jsx } from "react/jsx-runtime";
export default function FFInputControl(_ref) {
  let {
      inputProps = {},
      name,
      placeholder,
      validate = () => {}
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    input,
    meta
  } = useField(name, {
    validate
  });
  return /*#__PURE__*/_jsx(FormControl, Object.assign({}, rest, {
    error: meta.touched && meta.error,
    validationMessage: meta.touched && meta.error,
    verticalSeparation: "flush",
    children: /*#__PURE__*/_jsx(TextInput, Object.assign({}, input, inputProps, {
      placeholder: placeholder
    }))
  }));
}